<template>
  <el-dialog
    title="Forgot password"
    :visible.sync="showDlg"
    :append-to-body="true"
    :lock-scroll="false"
    width="80%"
  >
    <div>
      <img
        class="centerImage mb-4"
        src="../../../assets/images/email.svg"
        width="80`"
      />
      <div style="text-align: center" class="mb-4 mt-4">
        <p style="font-size:16px">
          Enter your email & click the button. We'll send you an email to help
          reset your password.
        </p>
      </div>
      <el-form
        v-on:submit.prevent.native="fnHandleSendResetEmail()"
        :rules="formRules"
        :model="form"
        class="centerFlex"
        ref="form"
        label-width="0px"
        label-position="left"
        :disabled="apiResetInProgress"
      >
        <el-form-item
          :show-message="false"
          prop="email"
          label-width="0"
          style="width:300px"
        >
          <el-input
            placeholder="you@example.com"
            size="large"
            v-model="form.email"
            @keyup.enter.native="fnHandleSendResetEmail()"
          >
            <i slot="prefix" class="el-input__icon material-icons input-icon"
              >email</i
            >
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="centerFlex mt-1">
      <el-button
        type="primary"
        @click="fnHandleSendResetEmail"
        :disabled="apiResetInProgress"
        >Send me a reset link</el-button
      >
    </div>
  </el-dialog>
</template>

<script type="text/babel">
import { mapActions, mapGetters } from "vuex";
import { sendResetPasswordEmail as apiSendResetPasswordEmail } from "@/modules/auth/api";

export default {
  name: "resetPasswordDialog",
  data() {
    return {
      form: {
        email: ""
      },
      formRules: {
        email: [
          {
            type: "email",
            required: true,
            trigger: "blur"
          }
        ]
      },
      apiResetInProgress: false
    };
  },
  computed: {
    // map store getters to local computed properties:
    ...mapGetters(["showForgotPasswordDialog", "getStorefrontId"]),
    showDlg: {
      get() {
        return this.showForgotPasswordDialog;
      },
      set() {
        this.uiHideForgotPasswordDialog();
      }
    }
  },
  methods: {
    ...mapActions(["uiHideForgotPasswordDialog", "uiShowForgotPasswordDialog"]),
    fnHandleSendResetEmail() {
      this.$refs["form"].validate(async valid => {
        if (valid) {
          this.apiResetInProgress = true;
          try {
            // note, this dialog is for storefront customers, whose
            // username/email is the same, and always of email syntax
            await apiSendResetPasswordEmail(
              this.form.email,
              this.getStorefrontId
            );
            this.fnOnResetOk();
          } catch (err) {
            console.error(err);
            this.fnOnResetFail();
          } finally {
            this.apiResetInProgress = false;
          }
        }
      });
    },
    fnOnResetOk() {
      this.$message({
        message: `Password reset link sent`,
        type: "success"
      });
      this.fnClose();
    },
    fnOnResetFail() {
      this.$message({
        message: `Failed to send reset link. Are you sure you have the right email?`,
        type: "error"
      });
      let strError = `Failed to send user a password reset email ${
        this.form.email
      }`;
      throw new Error(strError);
    },
    fnClose() {
      this.showDlg = false;
    }
  },
  mounted() {}
};
</script>
<style></style>
